import { Continent } from "./continent.model";
import { PaginationFilterRequest } from "./core.model";

export interface Country {
    id: number;
    name: string;
    alpha2Code: string;
    alpha3Code: string;
    flagImageUrl?: string;
    jsonGeometry?: string;
    continentId?: number;
    continent: Continent
}

export interface UpsertCountry {
    id?: number;
    name?: string;
    alpha2Code?: string;
    alpha3Code?: string;
    flagImageUrl?: string;
    continentId?: number
}

export class CountryPaginationFilterRequest extends PaginationFilterRequest{  
    continentId? : number;
}

export interface CountryGeometry {
    countryId: number;
    jsonGeometry: string;
}

export interface UpsertCountryGeometry {
    countryId?: number;
    jsonGeometry?: string;
}
